// apps/web/src/endpoints.ts
//
// Web-only configuration used by the React SPA.
// NOTE: GraphQL proxy endpoint for GraphqlQuery is now defined in
// packages/shared/src/endpoints.ts and shared by web + mobile.

function env(name: string): string {
  const value = process.env[name];
  if (!value) {
    // You can swap this to throw if you want hard failures:
    // throw new Error(`Missing required env var: ${name}`);
    // For now, keep it soft and return empty string.
    // eslint-disable-next-line no-console
    console.warn(`⚠️ Missing environment variable: ${name}`);
    return "";
  }
  return value;
}

export const publicAgentApiEndpoint = env("REACT_APP_PUBLICAGENTAPIENDPOINT");
export const privateAgentApiEndpoint = env("REACT_APP_PRIVATEAGENTAPIENDPOINT");

// ⚠️ GraphQL proxy endpoint is *not* defined here anymore.
// The shared GraphqlQuery / invokeGraphqlProxy use
// packages/shared/src/endpoints.ts instead.

export const cognitoConfig = {
  region: env("REACT_APP_REGION"),
  userPoolId: env("REACT_APP_COGNITOPOOL"),
  userPoolClientId: env("REACT_APP_COGNITOCLIENTAUTH"),
  userPoolDomain: env("REACT_APP_COGNITODOMAIN"),
  userPoolRedirectSignInUri: env("REACT_APP_COGNITOREDIRECTSIGNINURL"),
  userPoolRedirectSignOutUri: env("REACT_APP_COGNITOREDIRECTSIGNOUTURL"),
};

export const fmHandlerArns = [
  {
    label: "start",
    name: process.env.REACT_APP_HANDLERCLAUDESTART,
  },
  {
    label: "question-and-answer",
    name: process.env.REACT_APP_HANDLERCLAUDEQUESTIONANDANSWER,
  },
];

export const uploadTable = env("REACT_APP_UPLOADSTABLE");
export const eventTable = env("REACT_APP_EVENTSTABLE");
export const userTable = env("REACT_APP_USERSTABLE");

export const enableConfigureAgents =
  process.env.REACT_APP_ENABLECONSTRUCTINGAGENTS === "true";
